function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { getExtensionParams, mapAdPosition } from '../../../addons/reporting/common/metadata-ad-helper';
import { ConvivaMetaAdapter } from '../../../addons/reporting/conviva-addon/proposition/conviva-meta-adapter';
import { CoreVideoInternal } from '../../../core-video-internal';
import { OneAppConvivaTagsProvider } from './oneapp-conviva-tags-provider';
import { adaptMetadata, convertContentType } from '../../../addons/reporting/conviva-addon/proposition';
import { OneAppCustomAdTags, OneAppCustomContentTags } from './oneapp-reporting.enums';
import { getAdBreakForAd } from '../../../utils/ad-break-utils';
export { OneAppCustomAdTags, OneAppCustomContentTags } from './oneapp-reporting.enums';
// TODO: Change this after we have integrated with mParticle
var OneAppCustomTags = _object_spread({}, OneAppCustomContentTags, OneAppCustomAdTags);
export var OneAppConvivaMetaAdapter = /*#__PURE__*/ function(ConvivaMetaAdapter) {
    "use strict";
    _inherits(OneAppConvivaMetaAdapter, ConvivaMetaAdapter);
    function OneAppConvivaMetaAdapter() {
        _class_call_check(this, OneAppConvivaMetaAdapter);
        return _call_super(this, OneAppConvivaMetaAdapter, [
            new OneAppConvivaTagsProvider()
        ]);
    }
    _create_class(OneAppConvivaMetaAdapter, [
        {
            key: "getContentCustomTags",
            value: function getContentCustomTags(sessionItem, convivaAddonInfo, playoutData, session) {
                this.tagsProvider.updateContentData({
                    convivaAddonInfo: convivaAddonInfo,
                    sessionItem: sessionItem,
                    playoutData: playoutData
                });
                var deviceInfo = CoreVideoInternal.deviceInfo;
                var deviceNetworkStatus = CoreVideoInternal.networkStatus;
                var _obj;
                return _obj = {}, _define_property(_obj, OneAppCustomTags.TrackingId, this.tagsProvider.getSessionTrackingId() || ''), _define_property(_obj, OneAppCustomTags.AbTesting, this.tagsProvider.getAbTestingVariant() || ''), _define_property(_obj, OneAppCustomTags.AppSessionId, this.tagsProvider.getAppSessionId()), // TODO: Change this after we have integrated with mParticle
                _define_property(_obj, OneAppCustomTags.Brand, this.tagsProvider.getBrand()), _define_property(_obj, OneAppCustomTags.ConnectionType, this.tagsProvider.getConnectionType(deviceNetworkStatus)), _define_property(_obj, OneAppCustomTags.DeviceId, this.tagsProvider.getDeviceId()), _define_property(_obj, OneAppCustomTags.Entitlement, this.tagsProvider.getEntitlement()), _define_property(_obj, OneAppCustomTags.EpisodeNumber, this.tagsProvider.getEpisodeNumber()), _define_property(_obj, OneAppCustomTags.EpisodeTitle, this.tagsProvider.getEpisodeTitle()), _define_property(_obj, OneAppCustomTags.Geostation, this.tagsProvider.getCallSign()), _define_property(_obj, OneAppCustomTags.Mvpd, this.tagsProvider.getMvpd()), _define_property(_obj, OneAppCustomTags.Platform, this.tagsProvider.getDeviceBrand(deviceInfo)), _define_property(_obj, OneAppCustomTags.PlaybackStartPosition, this.tagsProvider.getStartPosition()), _define_property(_obj, OneAppCustomTags.PlayerVendor, 'CVSDK'), _define_property(_obj, OneAppCustomTags.PlayerVersion, convivaAddonInfo.coreVideoSdkVersion), _define_property(_obj, OneAppCustomTags.PreFetched, Boolean(session.isPrefetchedSession())), _define_property(_obj, OneAppCustomTags.Product, this.tagsProvider.getProductName()), _define_property(_obj, OneAppCustomTags.Profile, this.tagsProvider.getProfile()), _define_property(_obj, OneAppCustomTags.Season, this.tagsProvider.getSeason()), _define_property(_obj, OneAppCustomTags.Show, this.tagsProvider.getShow()), _define_property(_obj, OneAppCustomTags.StitchVendor, this.tagsProvider.getAdProvider()), _define_property(_obj, OneAppCustomTags.StreamProtocol, this.tagsProvider.getStreamProtocol()), _define_property(_obj, OneAppCustomTags.Syndicator, this.tagsProvider.getSyndicator()), _define_property(_obj, OneAppCustomTags.TmsShowID, this.tagsProvider.getTmsShowID()), _define_property(_obj, OneAppCustomTags.Version, convivaAddonInfo.applicationVersion), _define_property(_obj, OneAppCustomTags.VideoId, this.tagsProvider.getVideoId()), _define_property(_obj, OneAppCustomTags.VideoType, this.tagsProvider.getPlayoutType()), _define_property(_obj, OneAppCustomTags.Sport, this.tagsProvider.getVideoSport()), _define_property(_obj, OneAppCustomTags.League, this.tagsProvider.getVideoLeague()), _define_property(_obj, OneAppCustomTags.EventType, this.tagsProvider.getEventType()), _define_property(_obj, OneAppCustomTags.MutedVideoStart, this.tagsProvider.getMutedVideoStart()), _define_property(_obj, OneAppCustomTags.IsFromBackground, this.tagsProvider.isFromBackground()), _define_property(_obj, OneAppCustomTags.Language, this.tagsProvider.getVideoLanguage()), _define_property(_obj, OneAppCustomTags.StreamType, this.tagsProvider.getStreamType() || ''), _define_property(_obj, OneAppCustomTags.OptedOutSdks, this.tagsProvider.getOptedOutSdks()), _define_property(_obj, OneAppCustomTags.IsLive, this.tagsProvider.getIsLive()), _obj;
            }
        },
        {
            key: "getContentPredefinedTags",
            value: function getContentPredefinedTags(sessionItem, playoutData) {
                var _sessionItem_reporting, _adaptedMetadata_seasonNumber, _adaptedMetadata_episodeNumber, _adaptedMetadata_subGenre;
                var adaptedMetadata = adaptMetadata((_sessionItem_reporting = sessionItem.reporting) === null || _sessionItem_reporting === void 0 ? void 0 : _sessionItem_reporting.assetMetadata, playoutData);
                var genre;
                if (adaptedMetadata.genre !== undefined) {
                    genre = typeof adaptedMetadata.genre === 'string' ? adaptedMetadata.genre : convertContentType(adaptedMetadata.genre);
                }
                return {
                    'c3.cm.contentType': playoutData.type,
                    'c3.cm.channel': adaptedMetadata.channelId || '',
                    'c3.cm.brand': adaptedMetadata.brand || '',
                    'c3.cm.affiliate': '',
                    'c3.cm.categoryType': convertContentType(adaptedMetadata.contentType),
                    'c3.cm.name': '',
                    'c3.cm.id': adaptedMetadata.assetId || adaptedMetadata.channelId || '',
                    'c3.cm.seriesName': adaptedMetadata.seriesTitle || 'Null',
                    'c3.cm.seasonNumber': ((_adaptedMetadata_seasonNumber = adaptedMetadata.seasonNumber) === null || _adaptedMetadata_seasonNumber === void 0 ? void 0 : _adaptedMetadata_seasonNumber.toString()) || 'Null',
                    'c3.cm.showTitle': adaptedMetadata.assetTitle || 'Null',
                    'c3.cm.episodeNumber': ((_adaptedMetadata_episodeNumber = adaptedMetadata.episodeNumber) === null || _adaptedMetadata_episodeNumber === void 0 ? void 0 : _adaptedMetadata_episodeNumber.toString()) || 'Null',
                    'c3.cm.genre': genre || 'Null',
                    'c3.cm.genreList': ((_adaptedMetadata_subGenre = adaptedMetadata.subGenre) === null || _adaptedMetadata_subGenre === void 0 ? void 0 : _adaptedMetadata_subGenre.join(',')) || 'Null',
                    'c3.cm.utmTrackingUrl': ''
                };
            }
        },
        {
            key: "getAdPredefinedTags",
            value: function getAdPredefinedTags(playoutData, ad, sessionItem, convivaAddonInfo) {
                var _playoutData_cdns_;
                var defaultResource = (playoutData === null || playoutData === void 0 ? void 0 : (_playoutData_cdns_ = playoutData.cdns[0]) === null || _playoutData_cdns_ === void 0 ? void 0 : _playoutData_cdns_.name) || '';
                this.tagsProvider.updateContentData({
                    convivaAddonInfo: convivaAddonInfo,
                    sessionItem: sessionItem,
                    playoutData: playoutData
                });
                var _obj;
                return _object_spread((_obj = {}, _define_property(_obj, Conviva.Constants.ASSET_NAME, this.tagsProvider.getAdName(ad)), _define_property(_obj, Conviva.Constants.IS_LIVE, this.tagsProvider.getIsLive()), _define_property(_obj, Conviva.Constants.DURATION, this.tagsProvider.getAdDuration(ad)), _define_property(_obj, Conviva.Constants.STREAM_URL, this.tagsProvider.getStreamUrl()), _define_property(_obj, Conviva.Constants.STREAM_LEN, this.tagsProvider.getStreamLen()), _define_property(_obj, Conviva.Constants.VIEWER_ID, this.tagsProvider.getViewerId()), _define_property(_obj, Conviva.Constants.PLAYER_NAME, this.tagsProvider.getPlayerName()), _obj), defaultResource && _define_property({}, Conviva.Constants.DEFAULT_RESOURCE, defaultResource));
            }
        },
        {
            key: "getAdDefinedTags",
            value: function getAdDefinedTags(ad, availableAdBreaks, logger) {
                var extParams = getExtensionParams(ad, logger);
                var adBreak = getAdBreakForAd(ad, availableAdBreaks);
                var adPosition = mapAdPosition(extParams.position || adBreak.type.toLowerCase());
                var adSystem = 'FreeWheel';
                var adTechnology = 'Server Side Ad';
                var adStitcher = 'EMT';
                var creativeId = extParams.creativeId || ad.creativeId || 'NA';
                var creativeName = extParams.creativeName || ad.name || 'NA';
                var adBreakId = extParams.breakId || ad.adBreakId || 'NA';
                return {
                    'c3.ad.adStitcher': adStitcher,
                    'c3.ad.advertiserCategory': extParams.advertiserCategory || 'NA',
                    'c3.ad.advertiserId': extParams.advertiserId || 'NA',
                    'c3.ad.breakId': extParams.breakId || ad.adBreakId || 'NA',
                    'c3.ad.campaignName': extParams.campaignName || 'NA',
                    'c3.ad.creativeId': creativeId,
                    'c3.ad.creativeName': creativeName,
                    'c3.ad.firstAdId': adBreakId,
                    'c3.ad.firstAdSystem': adSystem,
                    'c3.ad.firstCreativeId': creativeId,
                    'c3.ad.id': extParams.id || ad.id,
                    'c3.ad.isSlate': Boolean(ad.isSlate).toString(),
                    'c3.ad.mediaFileApiFramework': extParams.mediaFileApiFramework || 'NA',
                    'c3.ad.position': adPosition,
                    // c3.ad.sequence resolved in getAdCustomTags
                    'c3.ad.system': adSystem,
                    'c3.ad.technology': adTechnology,
                    'c3.ad.type': 'NA'
                };
            }
        },
        {
            key: "getAdCustomTags",
            value: function getAdCustomTags(sessionItem, playoutData, convivaAddonInfo, ad, logger) {
                var _extParams_hulu, _extParams_hulu1, _extParams_adNetworkID, _extParams_hulu2;
                var extParams = getExtensionParams(ad, logger, {
                    hulu: true
                });
                var deviceInfo = CoreVideoInternal.deviceInfo;
                var deviceNetworkStatus = CoreVideoInternal.networkStatus;
                this.tagsProvider.updateContentData({
                    convivaAddonInfo: convivaAddonInfo,
                    sessionItem: sessionItem,
                    playoutData: playoutData
                });
                var _this_tagsProvider_getResellerName, _this_tagsProvider_getSiteSectionID, _extParams_sequence;
                var _obj;
                var customTags = (_obj = {}, _define_property(_obj, OneAppCustomTags.AppSessionId, this.tagsProvider.getAppSessionId()), // NOTE: Change this after we have integrated with mParticle https://wiki.inbcu.com/pages/viewpage.action?spaceKey=CVSDK&title=Conviva+Analytics
                _define_property(_obj, OneAppCustomTags.Brand, this.tagsProvider.getBrand()), _define_property(_obj, OneAppCustomTags.ConnectionType, this.tagsProvider.getConnectionType(deviceNetworkStatus)), _define_property(_obj, OneAppCustomTags.DeviceId, this.tagsProvider.getDeviceId()), _define_property(_obj, OneAppCustomTags.EpisodeTitle, this.tagsProvider.getEpisodeTitle()), _define_property(_obj, OneAppCustomTags.Platform, this.tagsProvider.getDeviceBrand(deviceInfo)), _define_property(_obj, OneAppCustomTags.Show, this.tagsProvider.getShow()), _define_property(_obj, OneAppCustomTags.VideoId, this.tagsProvider.getVideoId()), _define_property(_obj, OneAppCustomTags.VideoType, this.tagsProvider.getPlayoutType()), _define_property(_obj, OneAppCustomTags.CreativeDuration, extParams.duration), _define_property(_obj, OneAppCustomTags.MrmCampaignID, (_extParams_hulu = extParams.hulu) === null || _extParams_hulu === void 0 ? void 0 : _extParams_hulu.campaignId), _define_property(_obj, OneAppCustomTags.MrmCreativeRenditionID, extParams.renditionID), _define_property(_obj, OneAppCustomTags.MrmPlacementID, (_extParams_hulu1 = extParams.hulu) === null || _extParams_hulu1 === void 0 ? void 0 : _extParams_hulu1.placementId), _define_property(_obj, OneAppCustomTags.MrmResellerID, (_extParams_adNetworkID = extParams.adNetworkID) === null || _extParams_adNetworkID === void 0 ? void 0 : _extParams_adNetworkID.toString()), _define_property(_obj, OneAppCustomTags.MutedVideoStart, this.tagsProvider.getMutedVideoStart()), _define_property(_obj, OneAppCustomTags.PlacementName, (_extParams_hulu2 = extParams.hulu) === null || _extParams_hulu2 === void 0 ? void 0 : _extParams_hulu2.placementName), _define_property(_obj, OneAppCustomTags.SiteSection, extParams.sitesection), _define_property(_obj, OneAppCustomTags.SiteSectionTag, extParams.csid), _define_property(_obj, OneAppCustomTags.AdvertiserName, extParams.advertiser || ad.advertiser), _define_property(_obj, OneAppCustomTags.ResellerName, (_this_tagsProvider_getResellerName = this.tagsProvider.getResellerName()) !== null && _this_tagsProvider_getResellerName !== void 0 ? _this_tagsProvider_getResellerName : 'NA'), _define_property(_obj, OneAppCustomTags.MrmSiteSectionID, (_this_tagsProvider_getSiteSectionID = this.tagsProvider.getSiteSectionID()) !== null && _this_tagsProvider_getSiteSectionID !== void 0 ? _this_tagsProvider_getSiteSectionID : 'NA'), _define_property(_obj, OneAppCustomTags.ThirdPartyTagProvider, 'FreeWheel'), _define_property(_obj, OneAppCustomTags.Product, this.tagsProvider.getProductName()), _define_property(_obj, OneAppCustomTags.Version, convivaAddonInfo.applicationVersion), _define_property(_obj, OneAppCustomTags.IsFromBackground, this.tagsProvider.isFromBackground()), _define_property(_obj, OneAppCustomTags.sequence, String((_extParams_sequence = extParams.sequence) !== null && _extParams_sequence !== void 0 ? _extParams_sequence : 1)), _define_property(_obj, OneAppCustomTags.IsLive, this.tagsProvider.getIsLive()), _obj);
                return customTags;
            }
        }
    ]);
    return OneAppConvivaMetaAdapter;
}(ConvivaMetaAdapter);

//# sourceMappingURL=oneapp-conviva-meta-adapter.js.map